import { PENDING_DOCUMENTS } from "../../utils/constants"

const initialState = {
    documents: []
}

const pendingDocumentsReducer = (state = initialState, actions) => {
    const { type, payload } = actions
    switch (type) {
        case PENDING_DOCUMENTS: {
            return {
                ...state,
                documents: payload
            }
        }
        default: {
            return state
        }
    }
}

export default pendingDocumentsReducer